<!-- Colours apply to EVERY block (#226/#227); the rest only where the site renders them. -->
<div class="formgrid grid">
  <div class="field col-6 md:col-3">
    <label class="text-600 text-sm">Background colour</label>
    <app-colour-select [options]="backgroundOptions" [(ngModel)]="section.background" [ngModelOptions]="{ standalone: true }"
      placeholder="None (page background)"></app-colour-select>
    <small class="block text-500 mt-1">Blocks next to each other with the SAME colour join into one band.</small>
  </div>
  <div class="field col-6 md:col-3">
    <label class="text-600 text-sm">Text colour</label>
    <app-colour-select [options]="textColourOptions" [(ngModel)]="section.textColour" [ngModelOptions]="{ standalone: true }"
      placeholder="Default"></app-colour-select>
    <small class="block text-500 mt-1">Check it reads against the background — nothing stops an unreadable pair.</small>
  </div>

  <ng-container *ngIf="headingControls">
    <div class="field col-6 md:col-3">
      <label class="text-600 text-sm">Heading colour</label>
      <app-colour-select [options]="textColourOptions" [(ngModel)]="section.headingColour" [ngModelOptions]="{ standalone: true }"
        [placeholder]="headingColourPlaceholder" data-testid="heading-colour"></app-colour-select>
    </div>
    <!-- Heading level (#259): blank = H2, the size every block had before. -->
    <div class="field col-6 md:col-3">
      <label class="text-600 text-sm">Heading level</label>
      <p-dropdown [options]="headingLevelOptions" [(ngModel)]="section.headingLevel" [ngModelOptions]="{ standalone: true }"
        optionLabel="label" optionValue="value" placeholder="H2 (default)"
        styleClass="w-full" appendTo="body" data-testid="heading-level"></p-dropdown>
    </div>
    <div class="field col-6 md:col-3">
      <label class="text-600 text-sm">Heading alignment</label>
      <p-dropdown [options]="alignOptions" [(ngModel)]="section.align" [ngModelOptions]="{ standalone: true }"
        optionLabel="label" optionValue="value" placeholder="Left (default)"
        styleClass="w-full" appendTo="body" data-testid="block-align"></p-dropdown>
    </div>
  </ng-container>

  <ng-container *ngIf="blockControls">
    <div class="field col-6 md:col-3">
      <label class="text-600 text-sm">Button alignment</label>
      <p-dropdown [options]="buttonAlignOptions" [(ngModel)]="section.buttonAlign" [ngModelOptions]="{ standalone: true }"
        optionLabel="label" optionValue="value" [placeholder]="buttonAlignPlaceholder"
        styleClass="w-full" appendTo="body" data-testid="button-align"></p-dropdown>
      <small class="block text-500 mt-1">The links and buttons under the block.</small>
    </div>
    <div class="field col-6 md:col-3">
      <label class="text-600 text-sm">Spacing</label>
      <p-dropdown [options]="spacingOptions" [(ngModel)]="section.spacing" [ngModelOptions]="{ standalone: true }"
        optionLabel="label" optionValue="value" placeholder="Top and Bottom"
        styleClass="w-full" appendTo="body" data-testid="block-spacing"></p-dropdown>
      <small class="block text-500 mt-1">Space above and below the block. Take it off where two blocks should read as one.</small>
    </div>
    <div class="field col-6 md:col-3">
      <label class="text-600 text-sm" [attr.for]="'divider-' + section.id">Divider line below</label>
      <div class="flex align-items-center gap-2" style="min-height: 2.5rem">
        <p-inputSwitch [(ngModel)]="divider" [ngModelOptions]="{ standalone: true }" [inputId]="'divider-' + section.id"
          data-testid="block-divider"></p-inputSwitch>
        <span class="text-600 text-sm">{{ divider ? 'On' : 'Off' }}</span>
      </div>
      <small class="block text-500 mt-1">Turn it off to join this block to the next one.</small>
    </div>
  </ng-container>
</div>
